import { useCallback, useEffect } from "react";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
	FormHeaderComponent,
} from "../../components/styled/common";
import BackComponent from "../../components/BackComponent";
import MainButtonComponent from "../../components/MainButtonComponent";
import VolunteersExperienceForm, {
	applyExperienceLocalizableChanges,
	VolunteersExperienceGeneralValues,
	VolunteersExperienceLocalizableChanges,
} from "../../components/VolunteersExperienceForm";
import { useVolunteersExperienceContext } from "../../context/VolunteersExperienceContext/VolunteersExperienceContext";
import { VOLUNTEERS_EXPERIENCE_LIST_PATH } from "../../context/VolunteersExperienceContext/constants";
import { Culture } from "../../context/VolunteersHighlightContext/constants";

const AddVolunteersExperience = () => {
	const {
		addVolunteersExperience,
		clearVolunteersExperienceFormData,
		volunteersExperienceForm,
		setVolunteersExperienceForm,
		operationStatus,
	} = useVolunteersExperienceContext();

	useEffect(() => {
		clearVolunteersExperienceFormData();

		return () => {
			clearVolunteersExperienceFormData();
		};
	}, [clearVolunteersExperienceFormData]);

	const handleGeneralChange = useCallback((changes: Partial<VolunteersExperienceGeneralValues>) => {
		setVolunteersExperienceForm(prev => ({ ...prev, ...changes }));
	}, [setVolunteersExperienceForm]);

	const handleLocalizableChange = useCallback((culture: Culture, changes: VolunteersExperienceLocalizableChanges) => {
		setVolunteersExperienceForm(prev => ({
			...prev,
			volunteersExperienceLocalizable: applyExperienceLocalizableChanges(prev.volunteersExperienceLocalizable, culture, changes),
		}));
	}, [setVolunteersExperienceForm]);

	return (
		<>
			<BackComponent text="Deneyim Listesine Dön" to={VOLUNTEERS_EXPERIENCE_LIST_PATH} />
			<ActionContainer>
				<ActionItemsContainer>
					<FormHeaderComponent>Gönüllü Deneyimi Ekleme</FormHeaderComponent>
					<VolunteersExperienceForm
						general={volunteersExperienceForm}
						localizables={volunteersExperienceForm.volunteersExperienceLocalizable}
						isRequired
						onGeneralChange={handleGeneralChange}
						onLocalizableChange={handleLocalizableChange}
					/>
					<SubmitButtonOverlay>
						<MainButtonComponent
							onClick={addVolunteersExperience}
							loading={operationStatus.type === "loading" && operationStatus.operation === "add"}
						>
							Deneyim Ekle
						</MainButtonComponent>
					</SubmitButtonOverlay>
				</ActionItemsContainer>
			</ActionContainer>
		</>
	);
};

export default AddVolunteersExperience;
